// extracted by mini-css-extract-plugin
export default {"tvBlock":"styles_tvBlock__pCa7F"};